export default "__VITE_ASSET__BwFvlgl7__"